import { useQuery } from '@tanstack/react-query';
import { getInvoicePaymentMethods } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';

export default function useInvoicePaymentMethods() {
    const { data: paymentMethods = [], isLoading } = useQuery({
        queryKey: ['invoice-payment-methods'],
        queryFn: getInvoicePaymentMethods,
        onError: (error) => trackError(error),
    });

    return {
        paymentMethods,
        isLoading,
    };
}
